import React from "react";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/core/styles";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2)
    }
  }
}));

export default function WarningSnackbar(props) {
  const classes = useStyles();
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    props.setSnackbarState(false);
  };

  // Allow longer error messages (e.g. nested-zip detection) to stay
  // on-screen longer than the simple "upload limit" warning.
  const message = props.message || "Upload limit is 20 files";
  const duration = props.message ? 10000 : 4000;
  const severity = props.severity || "warning";

  return (
    <div className={classes.root}>
      <Snackbar open={props.open} autoHideDuration={duration} onClose={handleClose}>
        <Alert onClose={handleClose} severity={severity} style={{ whiteSpace: "pre-line" }}>
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
}
